var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91512 11.808C9.19912 9.04346 17.3311 5.67296 18.4536 5.20646C21.3981 3.98546 22.3016 4.21946 21.8511 6.92346C21.5276 8.86696 20.5941 15.3015 19.8501 19.3065C19.4086 21.6815 18.4181 21.963 16.8606 20.9355C16.1116 20.441 12.3311 17.941 11.5106 17.354C10.7616 16.819 9.72862 16.1755 11.0241 14.908C11.4851 14.4565 14.5071 11.571 16.8616 9.32496C17.1701 9.02996 16.7826 8.54546 16.4266 8.78196C13.2531 10.8865 8.85312 13.8075 8.29312 14.188C7.44712 14.7625 6.63462 15.026 5.17612 14.607C4.07412 14.2905 2.99762 13.913 2.57862 13.769C0.965115 13.215 1.34812 12.4975 2.91512 11.808Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.edb3cb17565c6e58a3fb0b8f990de87f.svg";
export { ForwardRef as ReactComponent };